const filters = {

	init() {
		document.querySelectorAll('.filters .br-toggle').forEach( function( element ) {
			element.toggle = Object.assign(new BRToggle(element, { accordion: false }));
			element.toggle.open(0);
		});		
	}
	
};

export { filters };
